<template>
    <path d="M11.2.99v3.79a7.26 7.26 0 0 0-6.42 6.41H.98v1.62h3.8a7.26 7.26 0 0 0 6.41 6.4V23h1.62v-3.78a7.26 7.26 0 0 0 6.4-6.41h3.76v-1.62h-3.76a7.26 7.26 0 0 0-6.4-6.4V.98h-1.62zm0 5.42v4.78H6.4a5.64 5.64 0 0 1 4.78-4.78zm1.6 0a5.64 5.64 0 0 1 4.79 4.78H12.8V6.41zm-6.39 6.4h4.78v4.78a5.64 5.64 0 0 1-4.78-4.78zm6.4 0h4.78a5.64 5.64 0 0 1-4.78 4.78V12.8z"/>
</template>

<script>
    export default {
        name: 'target_groups',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/TargetGroups.vue